export default __webpack_public_path__ + "static/media/52.e36c795d.png";